import React from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import Container from '../components/layout/Container';
import { useLanguage } from '../contexts/LanguageContext';
import { getDepartmentBySlug } from '../data/departments';
import Button from '../components/common/Button';
import './DepartmentDetail.css';

const DepartmentDetail = () => {
    const { slug } = useParams();
    const { language } = useLanguage();
    const dept = getDepartmentBySlug(slug);

    const deptIcons = {
        'computer-science': 'computer',
        'oil-gas': 'local_gas_station',
        'management': 'corporate_fare',
        'accounting': 'account_balance',
    };

    if (!dept) {
        return <Navigate to="/departments" />;
    }

    const content = dept[language];

    return (
        <div className="department-detail">
            <header className="dept-detail-header">
                <Container>
                    <div className="dept-detail-header__inner">
                        <Link to="/departments" className="dept-detail-header__back">
                            <span className="material-icons" style={{ fontSize: '18px' }}>arrow_back</span>
                            All Departments
                        </Link>
                        <div className="dept-detail-header__icon-wrapper">
                            <span className="material-icons dept-detail-header__icon">
                                {deptIcons[dept.slug] || 'school'}
                            </span>
                        </div>
                        <h1 className="dept-detail-header__title">{content.title}</h1>
                        <span className="dept-detail-header__established">
                            <span className="material-icons" style={{ fontSize: '16px' }}>calendar_today</span>
                            Established {dept.established}
                        </span>
                    </div>
                </Container>
            </header>

            <section className="section">
                <Container>
                    <div className="dept-detail-grid">
                        <div className="dept-detail-main">
                            <div className="dept-detail-block animate-fade-in">
                                <div className="dept-detail-block__header">
                                    <span className="material-icons dept-detail-block__icon">description</span>
                                    <h2 className="dept-detail-block__title">Overview</h2>
                                </div>
                                <p className="dept-detail-block__text">{content.description}</p>
                            </div>

                            {content.objectives && (
                                <div className="dept-detail-block animate-fade-in" style={{ animationDelay: '0.1s' }}>
                                    <div className="dept-detail-block__header">
                                        <span className="material-icons dept-detail-block__icon">flag</span>
                                        <h2 className="dept-detail-block__title">Objectives</h2>
                                    </div>
                                    <p className="dept-detail-block__text">{content.objectives}</p>
                                </div>
                            )}
                        </div>

                        <aside className="dept-detail-sidebar animate-fade-in" style={{ animationDelay: '0.2s' }}>
                            <div className="sidebar-card">
                                <h3 className="sidebar-card__title">Department Coordinator</h3>
                                <div className="coordinator-box">
                                    <div className="coordinator-box__avatar">
                                        {dept.coordinator.image ? (
                                            <img src={dept.coordinator.image} alt={dept.coordinator.name} />
                                        ) : (
                                            <span className="material-icons">person</span>
                                        )}
                                    </div>
                                    <div>
                                        <p className="coordinator-box__name">{dept.coordinator.name}</p>
                                        <p className="coordinator-box__role">Department Coordinator</p>
                                        <div className="coordinator-box__contact">
                                            <span className="material-icons" style={{ fontSize: '14px' }}>phone</span>
                                            <span>{dept.coordinator.phone}</span>
                                        </div>
                                        <div className="coordinator-box__contact" style={{ marginTop: 'var(--space-1)' }}>
                                            <span className="material-icons" style={{ fontSize: '14px' }}>email</span>
                                            <span style={{ wordBreak: 'break-all' }}>{dept.coordinator.email}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="sidebar-card">
                                <h3 className="sidebar-card__title">Department Contact</h3>
                                <ul className="sidebar-contact-list">
                                    <li>
                                        <span className="material-icons sidebar-contact-icon">email</span>
                                        <span>{dept.department_email}</span>
                                    </li>
                                </ul>
                            </div>

                            <Button variant="primary" className="w-full" href="/contact">
                                <span className="material-icons" style={{ fontSize: '18px', marginRight: '8px' }}>send</span>
                                Enquire Now
                            </Button>
                        </aside>
                    </div>
                </Container>
            </section>
        </div>
    );
};

export default DepartmentDetail;
